import React from 'react';
import {
  DataRoomNodeType,
  DATA_ROOM_NODE_TYPE,
} from 'router/subrouters/DataRoom/models/DataRoomNode';
import { DataRoomNodeProps } from './types';
import DataRoomFile from './components/DataRoomFile';
import DataRoomFolder from './components/DataRoomFolder';

export const NODE_COMPONENT: Record<
  DataRoomNodeType,
  (val: DataRoomNodeProps) => JSX.Element
> = {
  [DATA_ROOM_NODE_TYPE.FILE]: (props: DataRoomNodeProps) => (
    <DataRoomFile {...props} />
  ),
  [DATA_ROOM_NODE_TYPE.FOLDER]: (props: DataRoomNodeProps) => (
    <DataRoomFolder {...props} />
  ),
};
